// Qué producto se destaca en el cierre y qué nivel se sugiere (spec v4, 03/11/2026).
// Reglas r3: el producto es el que eligió la persona al entrar (declarado); si no hay, ninguno.
// En la Agencia, el tamaño del equipo sugiere el nivel (inferido).
// 🟠 La tabla equipo → nivel es criterio de Claude sobre la memoria, a validar por An:
// INICIAL es «la base individual» (§15e) · ASISTENCIA, hasta cinco tareas, una por puesto (§20A) ·
// ENERGIA, el sistema entero, que se cotiza según la empresa (§20A).
import { IDS_PRODUCTO } from './productos';
import { idDeOpcion } from './flows';

export const VERSION_REGLAS = 'r3';

// Por id de opción de `ia_equipo` (flows.js).
const NIVEL_POR_EQUIPO = { solo: 'INICIAL', de2a5: 'ASISTENCIA', de6a20: 'ASISTENCIA', mas_de_20: 'ENERGIA' };

export const nivelSugerido = (collected = {}) =>
  collected.producto === 'ia' ? NIVEL_POR_EQUIPO[idDeOpcion('ia_equipo', collected.equipo)] || null : null;

export const recomendar = (collected = {}) =>
  IDS_PRODUCTO.includes(collected.producto)
    ? { plan: collected.producto, motivo: 'declarado', nivel: nivelSugerido(collected) }
    : { plan: 'neutro', motivo: 'neutro', nivel: null };
